'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var klass = {
    active: 'is-active',
    current: 'is-current',
    fixed: 'is-fixed',
    view: 'is-view',
    selected: 'is-selected',
    hidden: 'is-hidden',
    error: 'is-error',
    eventNone: 'is-eventNone',
    landscape: 'is-landscape'
};

var commonUtil = commonUtil || {};
commonUtil = {
    modal: {
        /**
         * モーダル表示
         * @param title タイトル用テキスト String
         * @param content コンテンツ部HTML String
         * @param modalId 表示モーダルの指定(ID) String (#sampleModal)
         */
        open: function open(title, content, modalId) {
            if (!modalId) {
                modalId = '.modalCommon';
                if (title) {
                    $('.message-header', modalId).empty().show().html(title);
                } else {
                    $('.message-header', modalId).empty().hide();
                }
                if (content) {
                    $('.message-body', modalId).empty().html(content);
                } else {
                    $('.message-body', modalId);
                }
                $(modalId).fadeIn().css('display', 'flex');
            } else {
                if (title) {
                    $('.message-header', modalId).empty().show().html(title);
                } else {
                    $('.message-header', modalId).empty().hide();
                }
                if (content) {
                    $('.message-body', modalId).empty().html(content);
                } else {
                    $('.message-body', modalId);
                }
                $(modalId).fadeIn().css('display', 'flex');
            }
        },
        /**
         * モーダル非表示
         * @param content 閉じるボタンDOM指定
         */
        close: function close(content) {
            var _modal = $(content).closest('.modal');
            _modal.fadeOut();
        }
    },
    /**
     * ユーザーエージェント判定用関数
     * @returns ユーザーエージェントを返す
     */
    ua: {
        browser: function browser() {
            var userAgent = window.navigator.userAgent.toLowerCase();
            if (userAgent.indexOf('opera') !== -1) {
                return 'opera';
            } else if (userAgent.indexOf('edge') !== -1) {
                return 'edge';
            } else if (userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1) {
                return 'ie';
            } else if (userAgent.indexOf('chrome') !== -1) {
                return 'chrome';
            } else if (userAgent.indexOf('safari') !== -1) {
                return 'safari';
            } else if (userAgent.indexOf('firefox') !== -1) {
                return 'firefox';
            } else if (userAgent.indexOf('gecko') !== -1) {
                return 'gecko';
            } else {
                return false;
            }
        },
        os: function os() {
            var userAgent = window.navigator.userAgent.toLowerCase();

            if (userAgent.indexOf('iphone') !== -1) {
                return 'iphone';
            } else if (userAgent.indexOf('ipad') !== -1) {
                return 'ipad';
            } else if (userAgent.indexOf('android') !== -1) {
                return 'android';
            } else if (userAgent.indexOf('windows') !== -1) {
                return 'win';
            } else if (userAgent.indexOf('macintosh') !== -1) {
                return 'mac';
            } else {
                return false;
            }
        }
    },
    /**
     * スクロール制御関数: jQuery依存
     */
    scroll: {
        none: function none() {
            var scroll_event = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
            $(document).on(scroll_event, function (e) {
                e.preventDefault();
            });
            $(document).on('touchmove.noScroll', function (e) {
                e.preventDefault();
            });
        },
        active: function active() {
            var scroll_event = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
            $(document).off(scroll_event);
            $(document).off('.noScroll');
        }
    }
};

/**
 * author Christopher Blum
 *    - based on the idea of Remy Sharp, http://remysharp.com/2009/01/26/element-in-view-event-plugin/
 *    - forked from http://github.com/zuk/jquery.inview/
 */
!function (a) {
    "function" == typeof define && define.amd ? define(["jquery"], a) : "object" == (typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) ? module.exports = a(require("jquery")) : a(jQuery);
}(function (a) {
    function i() {
        var b,
            c,
            d = { height: f.innerHeight, width: f.innerWidth };return d.height || (b = e.compatMode, (b || !a.support.boxModel) && (c = "CSS1Compat" === b ? g : e.body, d = { height: c.clientHeight, width: c.clientWidth })), d;
    }function j() {
        return { top: f.pageYOffset || g.scrollTop || e.body.scrollTop, left: f.pageXOffset || g.scrollLeft || e.body.scrollLeft };
    }function k() {
        if (b.length) {
            var e = 0,
                f = a.map(b, function (a) {
                var b = a.data.selector,
                    c = a.$element;return b ? c.find(b) : c;
            });for (c = c || i(), d = d || j(); e < b.length; e++) {
                if (a.contains(g, f[e][0])) {
                    var h = a(f[e]),
                        k = { height: h[0].offsetHeight, width: h[0].offsetWidth },
                        l = h.offset(),
                        m = h.data("inview");if (!d || !c) return;l.top + k.height > d.top && l.top < d.top + c.height && l.left + k.width > d.left && l.left < d.left + c.width ? m || h.data("inview", !0).trigger("inview", [!0]) : m && h.data("inview", !1).trigger("inview", [!1]);
                }
            }
        }
    }var c,
        d,
        h,
        b = [],
        e = document,
        f = window,
        g = e.documentElement;a.event.special.inview = { add: function add(c) {
            b.push({ data: c, $element: a(this), element: this }), !h && b.length && (h = setInterval(k, 250));
        }, remove: function remove(a) {
            for (var c = 0; c < b.length; c++) {
                var d = b[c];if (d.element === this && d.data.guid === a.guid) {
                    b.splice(c, 1);break;
                }
            }b.length || (clearInterval(h), h = null);
        } }, a(f).on("scroll resize scrollstop", function () {
        c = d = null;
    }), !g.addEventListener && g.attachEvent && g.attachEvent("onfocusin", function () {
        d = null;
    });
});

$(function () {
    /**
     * UA チェック
     */
    document.querySelector('body').classList.add('is-' + commonUtil.ua.browser());
    document.querySelector('body').classList.add('is-' + commonUtil.ua.os());

    /**
     * 初期読み込み時ローダー非表示
     */
    var _winWidth = $(window).width();
    var _timeFlag = true;
    $(window).on('load', function () {

        if (!_timeFlag) {
            return false;
        }
        _timeFlag = false;
        openInit();
    });
    setTimeout(function () {
        if (!_timeFlag) {
            return false;
        }
        _timeFlag = false;
        openInit();
    }, 5000);

    function openInit() {
        $('.openLoader').addClass(klass.hidden);
        setTimeout(function () {
            $('.inview').on('inview', function (event, isInView) {
                var _this = $(this);
                if (isInView) {
                    _this.addClass(klass.view);
                    // } else {
                    // 	_this.removeClass(viewClass);
                }
            });
        }, 500);
    }

    /**
     * ナビゲーション固定
     */
    var hToggle = $('.navTrigger');
    var gNav = $('#header');
    /**
     * ナビゲーション開閉
     */
    hToggle.on('click touch', function () {
        gNav.toggleClass(klass.current);
    });

    gNav.find('#gNav a').on('click touch', function () {
        gNav.toggleClass(klass.current);
    });

    /**
     * ページスクローラ
     */
    $('a[href*="#"]').click(function () {
        if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
            var $target = $(this.hash);
            var $pos = $(this).data('pos') === 1 ? 30 : $(this).data('pos') === 2 ? 60 : $(this).data('pos') === 3 ? 90 : 0;
            $target = $target.length && $target || $('[name=' + this.hash.slice(1) + ']');
            if ($target.length) {
                var targetOffset = $target.offset().top;
                $('html,body').animate({ scrollTop: targetOffset - $pos }, 500);
                return false;
            }
        }
    });

    // 移植元 mascara.uruotte.com では Cloudflare Rocket Loader により本スクリプトが
    // window の load 発火後に実行されるため、この load ハンドラは一度も動かず
    // .bgMask01 / .bgMask02 は高さ 0 のまま描画されている。
    // 有効化すると白マスクが商品説明セクションの背景を隠してしまい移植元と表示が変わるため無効化している。
    //
    // $(window).on('load resize', function () {
    //     if (is_sp()) {
    //         $('.bgMask02').outerHeight($('#footer').outerHeight() + $('#itemList').height() + $('#HowTo').outerHeight() + $(window).width() * .3);
    //     } else {
    //         $('.bgMask02').outerHeight($('#footer').outerHeight() + $('#itemList').outerHeight() + $('#HowTo').outerHeight() + 300);
    //     }
    //     $('.bgMask01').outerHeight($('.mainVisual').outerHeight() + $('#index01').outerHeight());
    // });

    $(window).on('load scroll resize', function () {
        var _bg = $('.bg');
        var sTop = $(window).scrollTop();
        var wHeight = $(window).height();
        var productIB = $('#productIB .itemDescription');
        var productMB = $('#productMB .itemDescription');
        var productIBItem = $('#productIB .itemDetails');
        var productMBItem = $('#productMB .itemDetails');

        // let productIBstart = productIB.offset().top - (wHeight *.02);
        // let productMBstart = productMB.offset().top - (wHeight *.02);

        var productIBstart = productIB.offset().top;
        var productMBstart = productMB.offset().top;

        var productIBend = productIB.offset().top + productIB.outerHeight() - wHeight;
        var productMBend = productMB.offset().top + productMB.outerHeight() - wHeight;

        var _itemList = $('#itemList');

        if (_itemList.offset().top - wHeight * .8 <= sTop) {
            $('.modal').addClass('is-full');
        } else {
            $('.modal').removeClass('is-full');
        }

        if (sTop > 80) {
            $('#header').addClass(klass.view);
        } else {
            $('#header').removeClass(klass.view);
        }

        // 右カラムカラー変更
        if (productIBend >= sTop && sTop >= productIBstart) {
            _bg.addClass('is-activeIB');
            productIB.addClass('is-view2');
        } else {
            _bg.removeClass('is-activeIB');
            productIB.removeClass('is-view2');
        }

        if (productMBend > sTop && sTop > productMBstart) {
            _bg.addClass('is-activeMB');
            productMB.addClass('is-view2');
        } else {
            _bg.removeClass('is-activeMB');
            productMB.removeClass('is-view2');
        }
        if ($(window).width() < 768) {
            productIBItem.removeClass('is-fixed').css({ 'position': '', 'width': '', 'top': '', 'bottom': '' });
            productMBItem.removeClass('is-fixed').css({ 'position': '', 'width': '', 'top': '', 'bottom': '' });
        } else {
            if (productIB.offset().top + productIB.outerHeight() > sTop + productIBItem.outerHeight() - 1 && sTop >= $('#productIB .itemDetailsWrapper').offset().top && sTop >= productIBstart) {
                productIBItem.addClass('is-fixed').css({
                    'position': '',
                    'width': '',
                    'top': '',
                    'bottom': ''
                });
            } else if (productIB.offset().top + productIB.outerHeight() <= sTop + productIBItem.outerHeight()) {
                productIBItem.removeClass('is-fixed').css({
                    'position': 'absolute',
                    'width': '100%',
                    'top': 'auto',
                    'bottom': 0
                });
            } else {
                productIBItem.removeClass('is-fixed').css({
                    'position': 'absolute',
                    'width': '',
                    'top': '',
                    'bottom': ''
                });
            }

            if (productMB.offset().top + productMB.outerHeight() > sTop + productMBItem.outerHeight() - 1 && sTop >= $('#productMB .itemDetailsWrapper').offset().top && sTop > productMBstart) {
                productMBItem.addClass('is-fixed').css({
                    'width': '',
                    'top': '',
                    'bottom': ''
                });
            } else if (productMB.offset().top + productMB.outerHeight() <= sTop + productMBItem.outerHeight()) {
                productMBItem.removeClass('is-fixed').css({
                    'position': 'absolute',
                    'width': '100%',
                    'top': 'auto',
                    'bottom': 0
                });
            } else {
                productMBItem.removeClass('is-fixed').css({
                    'position': 'absolute',
                    'width': '',
                    'top': '',
                    'bottom': ''
                });
            }
        }
    });

    /**
     * モーダル開閉
     */
    $('.js-modal').on('click touch', function () {
        var _id = $(this).data('modal-id');
        commonUtil.modal.open('', null, _id);
    });

    $('.modal').on('click touch', '.modal-close', function () {
        commonUtil.modal.close(this);
    });

    /**
     * IE向けJSハック
     */
    if (commonUtil.ua.browser() === 'ie') {
        imgHeightSet();
        $(window).on('load resize', function () {
            imgHeightSet();
        });
    }
});

function imgHeightSet() {
    $(document).find('.itemDetails figure img').each(function (i, el) {
        var _this = $(this);
        _this.closest('figure').css('height', _this.height());
        console.log(_this.height());
    });
}

function is_sp() {
    return $(window).width() < 768;
}